import React from "react";
import ExplainerBar from "../../../shared/components/ExplainerBar/ExplainerBar";
import { Link } from "../../../shared/components/Link/Link";
import MatchTile from "../../../shared/components/MatchTile/MatchTile";
import { formatMlsMatchScores, slugifyMatch, statusTypes, useMatchData } from "../../utils";
import { MatchBroadcaster } from "../MatchBroadcaster/MatchBroadcaster";
import { MatchInfo } from "../MatchInfo/MatchInfo";
import { MatchTime } from "../MatchTime/MatchTime";
import { MatchWatch } from "../MatchWatch/MatchWatch";
import {
  StyledBroadcastersWrapper,
  StyledExplainerBar,
  StyledExplainerBarCompetition,
  StyledMatch,
  StyledMatchContainer,
} from "./StyledMatch";
import useIsMobile from "../../../shared/hooks/useIsMobile";
import MatchListPromo from "../MatchPromo/MatchPromo";
import { useReactAppState } from "../../../shared/containers/utils";

export const Match = ({
  position = null,
  hideMatchPromos,
  showClubRanks = false,
  showCompetitionStage = false,
  showRoundDetail = false,
  showGroupInformation = false,
}) => {
  const {
    homeClubData,
    awayClubData,
    homeClubRank,
    awayClubRank,
    status,
    winnerStatus,
    matchPageUrl,
    competition,
    leagueMatchTitle,
    mediaProviders,
    matchSportecId,
    competitionPhase,
    roundName,
    roundGroup,
    hotelBooking,
    mlsMatch,
  } = useMatchData();

  const { t } = useReactAppState();
  const { isHomeWinner, isAwayWinner } = winnerStatus || {};

  const isMobile = useIsMobile();

  const { home_score: homeScore, away_score: awayScore, shootout_result: shootoutResult } = formatMlsMatchScores({ match: mlsMatch });

  const isFriendlyMatch = matchSportecId <= 0;

  const handleMatchClick = (event) => {
    if (isFriendlyMatch) {
      event.stopPropagation();
    }
  };

  const roundInfo = [
    showCompetitionStage ? t(slugifyMatch(competitionPhase)) : null,
    showRoundDetail ? t(slugifyMatch(roundName)) : null,
    showGroupInformation ? t(slugifyMatch(roundGroup)) : null,
  ];
  const composedInfo = roundInfo.filter((x) => x).join(" � ");

  return (
    <StyledMatchContainer
      className={`mls-c-match-list__match-container ${isMobile ? "--mobile" : ""
        }`}
    >
      <StyledMatch className="mls-c-match-list__match">
        <MatchTime abbreviateStatus />
        <Link
          url={isFriendlyMatch ? null : matchPageUrl}
          onClick={handleMatchClick}
        >
          <StyledExplainerBarCompetition
            className="mls-c-match-list__match-competition"
            style={{ marginBottom: composedInfo ? "4px" : "8px" }}
          >
            <ExplainerBar
              fontStyle="normal"
              text={leagueMatchTitle ? leagueMatchTitle : competition?.name}
            />
            <ExplainerBar
              fontStyle="normal"
              text={composedInfo ? composedInfo : ""}
            />
          </StyledExplainerBarCompetition>
          <MatchTile
            hasAbbreviation
            hasShortName
            status={status}
            homeClubData={homeClubData}
            awayClubData={awayClubData}
            isHomeWinner={isHomeWinner}
            isAwayWinner={isAwayWinner}
            homeScore={homeScore}
            awayScore={awayScore}
            homeClubRank={showClubRanks ? homeClubRank : null}
            awayClubRank={showClubRanks ? awayClubRank : null}
          />
          {shootoutResult && (
            <StyledExplainerBar>
              <ExplainerBar text={shootoutResult} />
            </StyledExplainerBar>
          )}
          {(status?.abbreviation === statusTypes.pre ||
            status?.abbreviation === statusTypes.live) &&
            mediaProviders?.allProvidersList?.length > 0 && (
              <StyledBroadcastersWrapper className="mls-c-match-list__match-broadcaster__wrapper">
                <MatchBroadcaster />
              </StyledBroadcastersWrapper>
            )}
          {!isMobile && !hideMatchPromos && <MatchListPromo />}
        </Link>
        <MatchInfo roundInfo={composedInfo} />
        <MatchWatch position={position} showChevron={isMobile} />
      </StyledMatch>
      {isMobile && !hideMatchPromos && <MatchListPromo />}
    </StyledMatchContainer>
  );
};
